import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import PendingLicencePurchaseService from "../services/PendingLicencePurchaseService";

const usePendingLicencePurchaseService = () => {
  const { client } = useApiContext();

  const service = useMemo(() => {
    return new PendingLicencePurchaseService(client);
  }, [client]);

  return service;
};

export default usePendingLicencePurchaseService;
